/**
 * Контракты версий матрицы методики (E06.3, ФТ-3.6, Архитектура 6.3).
 * Исходный xlsx хранится в MinIO; runtime-расчёт идёт по EAV, не по файлу.
 */

import { z } from "zod";
import { apiSuccessSchema } from "./envelope";

export const matrixVersionStatusSchema = z.enum(["validated", "rejected"]);

export type MatrixVersionStatus = z.infer<typeof matrixVersionStatusSchema>;

/** Отчёт проверки книги (скан формул / контейнер). */
export const matrixValidationReportSchema = z.object({
  code: z.string().optional(),
  message: z.string(),
  sheets: z.array(z.string()).optional(),
  formulaCount: z.number().int().nonnegative().optional(),
  issues: z
    .array(
      z.object({
        sheet: z.string(),
        cell: z.string(),
        formula: z.string(),
        functions: z.array(z.string()),
      }),
    )
    .optional(),
});

export type MatrixValidationReport = z.infer<typeof matrixValidationReportSchema>;

export const matrixVersionSchema = z.object({
  id: z.string().uuid(),
  modelId: z.string().uuid(),
  versionNo: z.number().int().positive(),
  status: matrixVersionStatusSchema,
  isActive: z.boolean(),
  originalName: z.string().min(1).max(512),
  uploadedAt: z.string().datetime({ offset: true }),
  validationReport: matrixValidationReportSchema.nullable(),
});

export type MatrixVersion = z.infer<typeof matrixVersionSchema>;

export const matrixVersionListResponseSchema = apiSuccessSchema(z.array(matrixVersionSchema));
export const matrixVersionResponseSchema = apiSuccessSchema(matrixVersionSchema);
